
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"20","height":"20","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M9.03 10.005v.296c.01 1.17.081 2.214.203 2.876 0 .012.133.668.217.887.133.316.373.584.674.753.24.121.493.183.758.183.208-.01.55-.114.796-.202l.203-.078c1.347-.535 3.923-2.284 4.909-3.353l.073-.075.324-.35c.205-.268.313-.596.313-.948 0-.316-.096-.632-.29-.887a2.988 2.988 0 00-.232-.279l-.316-.33C15.575 7.396 13.22 5.852 12 5.34c0-.011-.758-.328-1.12-.34h-.047c-.554 0-1.071.316-1.336.826-.072.14-.141.413-.194.653l-.095.453c-.108.73-.18 1.847-.18 3.073zm-5.277-1.27C3.06 8.735 2.5 9.3 2.5 10c0 .698.56 1.264 1.253 1.264l3.082-.272A.987.987 0 007.818 10a.988.988 0 00-.983-.993l-3.082-.272z","fill":"#200E32","opacity":".5"}})])
          )
        }
      }
    